'use client';
import { styled } from 'styled-components';
import Button from '@/components/atoms/Button';
import ContentText from '@/components/atoms/ContentText';
import Image from 'next/image';
import Link from 'next/link';
import useWidth from '@/util/useWidth';
import { Metadata } from 'next';

export const metadata: Metadata = {
  title: 'ページをうまく表示できませんでした | NTH オンライン',
};

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { isMobile } = useWidth();
  return (
    <html>
      <body>
        <Container>
          <Image
            src="https://bucketeer-7f8bc701-2926-4975-840a-81a00f007653.s3.us-east-1.amazonaws.com/public/error.webp"
            alt="ページをうまく表示できませんでしたと伝えるエラー画像"
            height={isMobile ? 180 : 241}
            width={isMobile ? 268 : 358}
            className="Image_box"
          />
          <div className="message_box">
            {isMobile ? (
              <>
                <ContentText className="big">ページをうまく表示</ContentText>
                <ContentText className="big">できませんでした</ContentText>
                <ContentText className="margin-top">
                  お手数をおかけしますが、
                </ContentText>
                <ContentText>再度アクセスをお試しください。</ContentText>
                <ContentText className="margin-top">
                  エラーが解消されない場合は
                </ContentText>
                <ContentText>以下にお問い合わせください。</ContentText>
                <div className="message_box">
                  <ContentText className="big top">0120-682-280</ContentText>
                  <ContentText>有人受付時間：10:00 ~ 18:00</ContentText>
                  <ContentText>土曜・日曜・祝日、年末年始を除く</ContentText>
                </div>
              </>
            ) : (
              <>
                <ContentText className="big">
                  ページをうまく表示できませんでした
                </ContentText>
                <ContentText>
                  お手数をおかけしますが、再度アクセスをお試しください。
                </ContentText>
                <ContentText>
                  エラーが解消されない場合は以下にお問い合わせください。
                </ContentText>
                <div className="message_box">
                  <ContentText className="big top">0120-682-280</ContentText>
                  <ContentText>有人受付時間：10:00 ~ 18:00</ContentText>
                  <ContentText>土曜・日曜・祝日、年末年始を除く</ContentText>
                </div>
              </>
            )}
          </div>
          <Link href={'/'} className="button_box">
            <Button label="TOP画面に戻る"></Button>
          </Link>
        </Container>
      </body>
    </html>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  a {
    text-decoration: none;
    color: inherit;
  }
  .button_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 50%;
  }
  .Image_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
  .message_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 40px;
    .top {
      font-size: 37px;
      margin-top: 20px;
    }
    .margin-top {
      margin-top: 10px;
    }
  }
  .big {
    font-size: 25px;
  }
`;
